import { render } from "./PhotoCard.vue?vue&type=template&id=2b2b80f4"
import script from "./PhotoCard.vue?vue&type=script&lang=js"
export * from "./PhotoCard.vue?vue&type=script&lang=js"

import "./PhotoCard.vue?vue&type=style&index=0&id=2b2b80f4&lang=stylus"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__